// extracted by mini-css-extract-plugin
module.exports = {"r-mobile":"sectionExpandedArea_r-mobile__PB9mb","r-not-mobile":"sectionExpandedArea_r-not-mobile__oLZfu","container":"sectionExpandedArea_container__KR920"};